// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AOWxRM8bMIpXYTyvaxoL {
  margin-bottom: 8px;
  text-align: left;
  margin-left: 10px;
  margin-top: 5px;
}

.ujvQIQmfGx2W8VVGHdRR {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.v_lsu0_uURIZ94nI2Q2o > .r5mbUtMuEHnYQn2HxKaW > input.bZQAJlOSjFRVgjyqqSLk {
  width: 100px;
  height: 25px;
  border: none;
  background: none;
}

.ad8Xkf4Rrdx_Zooks28Q > .endxbD0ZT1vEcFvOOpJM > input.hOMUZgMqV7rWsgRSPxnP {
  width: 100%;
  height: 32px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]};
  box-sizing: border-box;
  padding-left: 8px;
  margin-bottom: 0px;
}

.ad8Xkf4Rrdx_Zooks28Q > .endxbD0ZT1vEcFvOOpJM > input.kvkIDiqpSoaW0EyOPX9G {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border: none;
  border-radius: 5px;
  outline: none;
  margin: 8px 0;
}

.ad8Xkf4Rrdx_Zooks28Q > .endxbD0ZT1vEcFvOOpJM > input.kvkIDiqpSoaW0EyOPX9G::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
  cursor: pointer;
}

.ad8Xkf4Rrdx_Zooks28Q > .endxbD0ZT1vEcFvOOpJM > input.kvkIDiqpSoaW0EyOPX9G::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
  cursor: pointer;
}

div .r_0oTjvimN39PHZqFJgq, div .ZLTIMiiemtO1yzz_sH99 {
  font-size: 14px;
  display: inline-block;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.r_0oTjvimN39PHZqFJgq {
  float: left;
  margin-left: 10px;
}

.ZLTIMiiemtO1yzz_sH99 {
  float: right;
  margin-right: 10px;
}

.v_lsu0_uURIZ94nI2Q2o {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.r5mbUtMuEHnYQn2HxKaW {
  border: 1px solid #f5f7ff;
  background-color: #f5f7ff;
  border-radius: 5px;
  float: right;
  padding-left: 25px;
}

/*Chrome*/
@media screen and (-webkit-min-device-pixel-ratio:0) {
    input[type='range'] {
      overflow: hidden;
      -webkit-appearance: none;
      background-color: #f5f7ff;
    }

    input[type='range']::-webkit-slider-thumb {
      -webkit-appearance: none;
      box-shadow: -505px 0px 0px 500px ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    }

}
/** FF*/
input[type="range"]::-moz-range-progress {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}; 
}
input[type="range"]::-moz-range-track {  
  background-color: #f5f7ff;
}
/* IE*/
input[type="range"]::-ms-fill-lower {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}; 
}
input[type="range"]::-ms-fill-upper {  
  background-color: #f5f7ff;
}`, "",{"version":3,"sources":["webpack://./src/components/library/Input/InputRange/InputRange.module.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mDAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8DAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wDAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wDAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mDAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,SAAS;AACT;IACI;MACE,gBAAgB;MAChB,wBAAwB;MACxB,yBAAyB;IAC3B;;IAEA;MACE,wBAAwB;MACxB,6EAA6C;IAC/C;;AAEJ;AACA,OAAO;AACP;EACE,8DAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA,MAAM;AACN;EACE,8DAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["@value colors: \"../../style/colors.css\";\n@value color-purple, color-text-subtle, color-text from colors;\n\n.label {\n  margin-bottom: 8px;\n  text-align: left;\n  margin-left: 10px;\n  margin-top: 5px;\n}\n\n.required {\n  color: color-purple;\n}\n\n.rowAlign > .boxValue > input.inputBoxValue {\n  width: 100px;\n  height: 25px;\n  border: none;\n  background: none;\n}\n\n.mainDiv > .divInputRange > input.inputRange {\n  width: 100%;\n  height: 32px;\n  border: 1px solid color-text;\n  box-sizing: border-box;\n  padding-left: 8px;\n  margin-bottom: 0px;\n}\n\n.mainDiv > .divInputRange > input.slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 10px;\n  border: none;\n  border-radius: 5px;\n  outline: none;\n  margin: 8px 0;\n}\n\n.mainDiv > .divInputRange > input.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: color-purple;\n  cursor: pointer;\n}\n\n.mainDiv > .divInputRange > input.slider::-moz-range-thumb {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: color-purple;\n  cursor: pointer;\n}\n\ndiv .minLabel, div .maxLabel {\n  font-size: 14px;\n  display: inline-block;\n  color: color-text-subtle;\n}\n\n.minLabel {\n  float: left;\n  margin-left: 10px;\n}\n\n.maxLabel {\n  float: right;\n  margin-right: 10px;\n}\n\n.rowAlign {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.boxValue {\n  border: 1px solid #f5f7ff;\n  background-color: #f5f7ff;\n  border-radius: 5px;\n  float: right;\n  padding-left: 25px;\n}\n\n/*Chrome*/\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n    input[type='range'] {\n      overflow: hidden;\n      -webkit-appearance: none;\n      background-color: #f5f7ff;\n    }\n\n    input[type='range']::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      box-shadow: -505px 0px 0px 500px color-purple;\n    }\n\n}\n/** FF*/\ninput[type=\"range\"]::-moz-range-progress {\n  background-color: color-purple; \n}\ninput[type=\"range\"]::-moz-range-track {  \n  background-color: #f5f7ff;\n}\n/* IE*/\ninput[type=\"range\"]::-ms-fill-lower {\n  background-color: color-purple; \n}\ninput[type=\"range\"]::-ms-fill-upper {  \n  background-color: #f5f7ff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]}`,
	"label": `AOWxRM8bMIpXYTyvaxoL`,
	"required": `ujvQIQmfGx2W8VVGHdRR`,
	"rowAlign": `v_lsu0_uURIZ94nI2Q2o`,
	"boxValue": `r5mbUtMuEHnYQn2HxKaW`,
	"inputBoxValue": `bZQAJlOSjFRVgjyqqSLk`,
	"mainDiv": `ad8Xkf4Rrdx_Zooks28Q`,
	"divInputRange": `endxbD0ZT1vEcFvOOpJM`,
	"inputRange": `hOMUZgMqV7rWsgRSPxnP`,
	"slider": `kvkIDiqpSoaW0EyOPX9G`,
	"minLabel": `r_0oTjvimN39PHZqFJgq`,
	"maxLabel": `ZLTIMiiemtO1yzz_sH99`
};
export default ___CSS_LOADER_EXPORT___;
